import axios from '@/plugins/axios'

import { useAuthorizationStore } from '@/store/authorizationStore'

const getAccountId = () => useAuthorizationStore().getAccountSlug

const getVerificationData = () => axios.get(`${getAccountId()}/verification`)

const updateVerificationBilling = (formData) => axios.post(`${getAccountId()}/verification/billing`, formData)

const updateVerificationKYC = ({ formData, config }) => axios.post(`${getAccountId()}/verification/kyc`, formData, config)

const updateVerificationCard = ({ formData, config }) => axios.post(`${getAccountId()}/verification/payment`, formData, config)

const createVerification = () => axios.post(`${getAccountId()}/verification/verification-url`)
const getStripeUrl = (type) => axios.get(`${getAccountId()}/verification/customer-portal/${type}`)
const getVerificationStatus = () => axios.get(`${getAccountId()}/verification/status`)
const getVerificationCardStatus = () => axios.get(`${getAccountId()}/verification/card/status`)

export {
    createVerification,
    getVerificationData,
    getVerificationStatus,
    getVerificationCardStatus,
    updateVerificationBilling,
    updateVerificationKYC,
    updateVerificationCard,
    getStripeUrl,
}
